import { axiosEduServer } from "../utils/configAxios";

export const crearGrupo = (data) => {
  return axiosEduServer.post('/grupo', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarGrupo = (id, data) => {
  return axiosEduServer.put(`/grupo/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarGrupo = (id) => {
  return axiosEduServer.delete(`/grupo/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getOneGrupo = (id) => {
  return axiosEduServer.get(`/grupo/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllGrupos = () => {
  return axiosEduServer.get('/grupo').then(({ data }) => data).catch((err) => { throw err });
};

export const getAllGruposByIdNivelByModuloByIdIdiomaByIdTurno = (idNivel, idModulo, idIdioma, idTurno) => {
  return axiosEduServer.get(`/grupo/idnivel/${idNivel}/idModulo/${idModulo}/ididioma/${idIdioma}/idturno/${idTurno}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllGruposByIdDocenteIdIdioma = (idDocente, idIdioma) => {
  return axiosEduServer.get(`/grupo/iddocente/${idDocente}/ididioma/${idIdioma}`).then(({ data }) => data).catch((err) => { throw err });
};

export const unirGrupos = (data) => {
  return axiosEduServer.post('/grupo/unir', data)
    .then(({ data }) => data)
    .catch((err) => { throw err });
};

export const descargarNotasGrupo = (idGrupo) => {
  return axiosEduServer.get(`/grupo/descargar-notas/${idGrupo}`, {
    responseType: 'blob' 
  })
  .then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    
    const contentDisposition = response.headers['content-disposition'];
    let fileName = `Notas_Grupo_${idGrupo}.xlsx`;
    
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = fileNameMatch[1];
      }
    }
    
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  })
  .catch((err) => { 
    throw err;
  });
};

export const exportarAsistenciaGrupo = (idGrupo) => {
  return axiosEduServer.get(`/grupo/exportar-asistencia/${idGrupo}`, {
    responseType: 'blob' 
  })
  .then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    
    const contentDisposition = response.headers['content-disposition'];
    let fileName = `Asistencia_${new Date().toISOString().slice(0, 10).replace(/-/g, '')}.xlsx`;
    
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = fileNameMatch[1];
      }
    }
    
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  })
  .catch((err) => { 
    throw err;
  });
};
export const exportarUsernameGrupo = (idGrupo) => {
  return axiosEduServer.get(`/grupo/grupo/${idGrupo}/exportar-estudiantes`, {
    responseType: 'blob' }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const contentDisposition = response.headers['content-disposition'];
    let fileName = `Usernames_${idGrupo}.xlsx`;
    if (contentDisposition) {
      const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (fileNameMatch && fileNameMatch[1]) {
        fileName = fileNameMatch[1];
      }
    }
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  })
  .catch((err) => { 
    throw err;
  });
};


